import React from 'react';
import { Heart, UserCheck, Users } from 'lucide-react';
import { motion } from 'framer-motion';
import { Event } from '../types/supabase';
import { SignupKind } from './SignupModal';

interface SignupButtonsProps {
  event: Pick<Event, 'allow_volunteers' | 'allow_attendees'>;
  volunteerCount: number;
  attendeeCount: number;
  onSelect: (kind: SignupKind) => void;
}

const SignupButtons: React.FC<SignupButtonsProps> = ({ event, volunteerCount, attendeeCount, onSelect }) => {
  const showVolunteer = event.allow_volunteers !== false;
  const showAttend = event.allow_attendees === true;

  if (!showVolunteer && !showAttend) return null;

  return (
    <div className="flex flex-wrap items-center justify-end gap-3">
      {showAttend && attendeeCount > 0 && (
        <span className="inline-flex items-center text-sm text-gray-600">
          <UserCheck className="w-4 h-4 mr-1 text-emerald-600" />
          {attendeeCount} attending
        </span>
      )}
      {showVolunteer && volunteerCount > 0 && (
        <span className="inline-flex items-center text-sm text-gray-600">
          <Users className="w-4 h-4 mr-1 text-red-500" />
          {volunteerCount} volunteering
        </span>
      )}
      {showAttend && (
        <motion.button
          type="button"
          onClick={() => onSelect('attendee')}
          className="bg-emerald-600 hover:bg-emerald-700 text-white py-2 px-4 rounded-md font-medium transition-colors flex items-center space-x-2"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <UserCheck className="w-4 h-4" />
          <span>Attend</span>
        </motion.button>
      )}
      {showVolunteer && (
        <motion.button
          type="button"
          onClick={() => onSelect('volunteer')}
          className="bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-md font-medium transition-colors flex items-center space-x-2"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Heart className="w-4 h-4" />
          <span>Volunteer</span>
        </motion.button>
      )}
    </div>
  );
};

export default SignupButtons;
